<micro-select-combo #sel
              placeholder="SMSC Manager"
              routerBase="smsc/smscManagers"
              [(id)]="smscManagerId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
